import useStory, { span } from './useStory';
import { Explainer } from './GuideParts';

// GUIDE 5'S ANIMATION (Oct 2026): two same rooms, one AC set to 18°C and one
// to 24°C. Both cool at the same speed (the Ministry of Power: a lower
// setting does not cool faster). The 24°C one reaches its number and slows
// down; the 18°C one keeps going at full power. A bill under each counts up
// to a month's cost from the room model (sweep() in data/guideTemp.js).
//
// Props: low, high ({ setC, rupees } for 18°C and 24°C), watch, sources.

const START = 32;
const RATE_PER_T = 20;    // °C fall per unit of t: 8°C by t = 0.4, 14°C by t = 0.7
const inr10 = (n) => `₹${(Math.round(n / 10) * 10).toLocaleString('en-IN')}`;

function Room({ x, t }) {
  const temp = Math.max(x.setC, START - RATE_PER_T * t);
  const reachedAt = (START - x.setC) / RATE_PER_T;
  const reached = t >= reachedAt;
  const slow = span(t, reachedAt, reachedAt + 0.06);
  const power = 1 - 0.5 * slow;
  return (
    <div className="grid content-start justify-items-center gap-2 rounded-xl border border-gray-200 p-3 text-center">
      <p className="text-[15px] font-extrabold text-gray-900">Set to {x.setC}°C</p>
      <svg viewBox="0 0 40 100" width="34" height="86" aria-hidden="true">
        <rect x="14" y="6" width="12" height="70" rx="6" fill="#f3f4f6" stroke="#d1d5db" />
        <circle cx="20" cy="84" r="11" fill={reached ? '#2563eb' : '#dc2626'} />
        <rect x="16.5" y={10 + (70 - 10) * (1 - (temp - 16) / (START - 16))} width="7" height={66 - (70 - 10) * (1 - (temp - 16) / (START - 16))} rx="3.5" fill={reached ? '#2563eb' : '#dc2626'} />
      </svg>
      <p className="text-[28px] font-extrabold leading-none tabular-nums text-gray-900">{temp.toFixed(1)}°</p>
      <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-[13px] font-bold text-gray-800">{reached ? 'Slowed down' : 'Full power'}</span>
      <div className="h-3 w-full overflow-hidden rounded-full bg-gray-100" aria-hidden="true">
        <div className="h-full rounded-full bg-blue-600" style={{ width: `${Math.round(power * 100)}%` }} />
      </div>
      <p className="text-[13px] text-gray-600">Bill a month</p>
      <p className="-mt-1.5 text-[22px] font-extrabold tabular-nums text-gray-900">{inr10(x.rupees * t)}</p>
    </div>
  );
}

export default function TempRooms({ low, high, watch, sources }) {
  const story = useStory(18000);
  return (
    <Explainer title={watch.title} captions={watch.captions} story={story} note={watch.note} noteSrc={watch.noteSrc} sources={sources}>
      <div className="grid grid-cols-2 gap-2.5">
        <Room x={low} t={story.t} />
        <Room x={high} t={story.t} />
      </div>
    </Explainer>
  );
}
